import { Box, Stack, Heading, Text } from '@n26/nxd'
import { useTranslation } from 'react-i18next'
import { AppLayout } from '@/shared/components/AppLayout'
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle'
import UserInfo from '@/features/user/components/UserInfo'
import { TransactionList } from '@/features/transactions/components/TransactionList'

export const Home = () => {
  const { t } = useTranslation()
  useDocumentTitle(t('titles.home'))

  return (
    <AppLayout>
      <Stack direction='vertical' space='32'>
        <Heading level={1} variant='standard'>
          {t('home.title')}
        </Heading>
        <UserInfo />
        <Box
          padding='16'
          backgroundColor='wheat-alternate'
          borderRadius='8'
          role='status'
          aria-label={t('home.serviceNotice.ariaLabel')}
        >
          <Stack direction='vertical' space='4'>
            <Text variant='heading-small'>
              {t('home.serviceNotice.heading')}
            </Text>
            <Text variant='small'>
              {t('home.serviceNotice.body')}
            </Text>
          </Stack>
        </Box>
        <TransactionList />
      </Stack>
    </AppLayout>
  )
}
